import { render, staticRenderFns } from "./p07.vue?vue&type=template&id=9f9831c0&scoped=true&"
import script from "./p07.vue?vue&type=script&lang=js&"
export * from "./p07.vue?vue&type=script&lang=js&"
import style0 from "./p07.vue?vue&type=style&index=0&id=9f9831c0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9831c0",
  null
  
)

export default component.exports